"use strict";
/**
 * @module Services.UnsubscriptionNotification
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BEES = require("./../../serialisers/byte-encoded-enum-serialiser");
var serialiser_1 = require("./../../serialisers/serialiser");
var TopicIdSerialiser = require("./../../topics/details/topic-id-serialiser");
var topics_1 = require("../../../topics/topics");
var unsubscription_notification_1 = require("./unsubscription-notification");
/**
 * Serialiser for {@link UnsubscriptionNotification}
 */
var UnsubscriptionNotificationSerialiserClass = /** @class */ (function (_super) {
    __extends(UnsubscriptionNotificationSerialiserClass, _super);
    function UnsubscriptionNotificationSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link UnsubscriptionNotification} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link UnsubscriptionNotification} that was read
     */
    UnsubscriptionNotificationSerialiserClass.prototype.read = function (bis) {
        var id = TopicIdSerialiser.read(bis);
        var reason = BEES.read(bis, topics_1.UnsubscribeReasonEnum);
        return new unsubscription_notification_1.UnsubscriptionNotification(id, reason);
    };
    /**
     * Write a {@link UnsubscriptionNotification} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link UnsubscriptionNotification} to be written
     */
    UnsubscriptionNotificationSerialiserClass.prototype.write = function (bos, value) {
        TopicIdSerialiser.write(bos, value.id);
        if (value.reason.id === undefined) {
            throw new Error('Cannot serialise UnsubscribeReason ${value.reason.reason}');
        }
        BEES.write(bos, value.reason);
    };
    return UnsubscriptionNotificationSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.UnsubscriptionNotificationSerialiserClass = UnsubscriptionNotificationSerialiserClass;
/**
 * The {@link UnsubscriptionNotificationSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.UnsubscriptionNotificationSerialiser = new UnsubscriptionNotificationSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/unsubscription-notification/unsubscription-notification-serialiser.js
// module id = 2078
// module chunks = 1